/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://3kd6gmxdynbspiq4e75yiry2cy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-q27uv3gnhbauhnuwmvzrugr4bq",
    "aws_cognito_identity_pool_id": "us-east-1:81603311-aead-4e18-a324-da0379b67f35",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_IPIzd3WEF",
    "aws_user_pools_web_client_id": "6p8ecgq6te3i3trnfcff69aksd",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_mobile_analytics_app_id": "8e6cfbd619f2419880c9761ee62c8b76",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
